import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class DuplicatesPager extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: false,
			pager: 1
		};
	}

	toggleSelect = () => {
		this.setState({dropdownOpen: !this.state.dropdownOpen})
	}

	onClick = (pager) => {
		this.setState({pager: pager});
		this.props.updatePager(pager);
	}

	countFilter = () => {
		var count = 0;
		this.props.duplicates.map(p => {
			if (p.EmailMatch && this.props.filter === "email" ||
				  p.PhoneMatch && this.props.filter === "phone" ||
				  p.EmailMatch && p.PhoneMatch && this.props.filter === "both") {
				count++;
			}
		});
		return count;
	}

	render() {
		const {dropdownOpen, pager} = this.state;
		var count = this.countFilter();
		var pages = []
		for (var i = 0; i < Math.ceil(count / 1000); i++) {
			pages.push(i + 1);
		}
		return (
			<>
				{pages.length <= 1 ? null :
				<Dropdown isOpen={dropdownOpen} toggle={this.toggleSelect}>
					<DropdownToggle caret>
						{`Page ${pager}`}
					</DropdownToggle>
					<DropdownMenu>
						<DropdownItem header>Pager</DropdownItem>
						{pages.map(p => {
							return (
								<DropdownItem key={p} onClick={() => this.onClick(p)}>
									{p}
								</DropdownItem>
							);
						})}
					</DropdownMenu>
				</Dropdown>}
				{`There are ${count} duplicates matching this filter.`}
			</>
		);
	}
}

export default DuplicatesPager;
